import { render } from "./KatalogSemen.vue?vue&type=template&id=4ee39aae"
import script from "./KatalogSemen.vue?vue&type=script&lang=js"
export * from "./KatalogSemen.vue?vue&type=script&lang=js"

import "./KatalogSemen.vue?vue&type=style&index=0&id=4ee39aae&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__